import React from 'react';

const EditIcon = () => (
  <svg
    style={{ height: '30px', width: '30px', fill: '#999999' }}
    version="1.1"
    id="edit_svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 30 30"
    xmlSpace="preserve"
  >
    <polygon points="6,20.6 6,24.3 9.8,24.3 20.8,13.2 17.1,9.5 6,20.6 " />
    <path d="M23.7,10.3c0.4-0.4,0.4-1,0-1.4l-2.3-2.3c-0.4-0.4-1-0.4-1.4,0l-1.8,1.8l3.8,3.8L23.7,10.3L23.7,10.3z" />
  </svg>
);

export default EditIcon;
